<app-card-mask [hasMask]="hasMask">
  <mat-card
    class="summary-block"
    [style.background-color]="data.bgColor"
    [style.color]="getTextColor()"
  >
    <!-- Ícone de fundo com opacidade -->
    <div class="background-icon">
      <img [src]="data.icon" [alt]="data.title" class="icon">
    </div>

    <!-- Título no topo -->
    <div class="title-container">
      <h3 class="title">{{ data.title }}</h3>
    </div>

    <!-- Número no canto inferior direito -->
    <div class="value-container">
      <span class="value">{{ data.number }}</span>
    </div>

    <mat-card-actions class="button-container">
      <!-- Botão de Informação (esquerda) APENAS SE NÃO TIVER MÁSCARA E TIVER TOOLTIP -->
      <!-- Desktop: hover mostra tooltip, clique não faz nada -->
      <!-- Mobile: clique emite evento para abrir modal -->
      <button
        mat-icon-button
        class="info-button"
        [attr.data-tooltip]="data.tooltipText || ''"
        (click)="onInfoButtonClick($event)"
        *ngIf="!hasMask && data.tooltipText"
      >
        <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
      </button>
    </mat-card-actions>
  </mat-card>
</app-card-mask>
